import { useEffect, useState } from 'react';
import { obtenerUsuariosSistemaPorFiltro} from '../data/UsuarioSistema';
import { useContext } from "react";
import { AuthContext } from "auth";
export const useListarUsuariosSistema = () => {
    var {user,logout}= useContext(AuthContext)
    const [usuariosSistema, setUsuariosSistema] = useState([]);
    
    const getUsuariosSistema = async(filtro) => {
        const usuarios = await obtenerUsuariosSistemaPorFiltro(filtro,user.Token);
        setUsuariosSistema(usuarios);
    }
    
    useEffect( () => {
        async function setListarUsuariosSistema(){
            getUsuariosSistema();
        }
        setListarUsuariosSistema();
    }, []);
    
    return {
        usuariosSistema,
        getUsuariosSistema
        
    }

}
